import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconName } from '@fortawesome/pro-regular-svg-icons';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

import { NotAvailable } from '@bn/primitives';

import { DropdownMenuComponent } from '../dropdown-menu/dropdown-menu.component';
import { DropdownMenuItem } from '../dropdown-menu/models/dropdown-menu-item.model';
import { DropDownMenuOptions } from '../dropdown-menu/models/dropdown-menu-options.model';

@Component({
  selector: 'bn-web-ui-single-card-content',
  templateUrl: './single-card-content.component.html',
  styleUrls: ['./single-card-content.component.scss'],
  imports: [FaIconComponent, NgTemplateOutlet, RouterLink, DropdownMenuComponent, NgxSkeletonLoaderComponent],
})
export class SingleCardContentComponent {
  @Input()
  public heading = '';

  @Input()
  public description = '';

  @Input()
  public showSkeleton = false;

  @Input()
  public itemId = '';

  @Input()
  public iconName: IconName | null = null;

  @Input()
  public dropdownMenuItems: DropdownMenuItem[] | null = null;

  @Input()
  public set dropdownMenuOptions(optionsValues: DropDownMenuOptions) {
    this.overridenDropdownMenuOptions = {
      ...this.defaultDropdownMenuOptions,
      ...optionsValues,
    };
  }

  public readonly dropdownClickAction = output<DropdownMenuItem>();

  public readonly notAvailable = NotAvailable;
  public defaultDropdownMenuOptions: DropDownMenuOptions = { align: 'end', closeOnItemClick: true };
  public overridenDropdownMenuOptions!: DropDownMenuOptions;

  public onDropdownMenuClick(event: DropdownMenuItem, itemId: string): void {
    event.id = itemId;
    this.dropdownClickAction.emit(event);
  }
}
